import React, { useState } from 'react';
import {
  Button,
  Menu,
  MenuItem,
  ListItemText,
  ListItemIcon,
  Divider,
  Typography,
  Box,
  IconButton
} from '@mui/material';
import FolderOpenIcon from '@mui/icons-material/FolderOpen';
import StarIcon from '@mui/icons-material/Star';
import StarOutlinedIcon from '@mui/icons-material/StarOutlined';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import SettingsIcon from '@mui/icons-material/Settings';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

const SavedQueriesMenu = ({
  savedQueries,
  onLoadQuery,
  onDeleteQuery,
  onRenameQuery,
  onDuplicateQuery,
  onToggleFavorite,
  onManageAll
}) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLoadQuery = (query) => {
    onLoadQuery(query);
    handleClose();
  };

  const handleAction = (action, query, event) => {
    event.stopPropagation();
    action(query);
  };

  // Sort queries: favorites first, then by modified date
  const sortedQueries = [...(savedQueries || [])].sort((a, b) => {
    if (a.isFavorite && !b.isFavorite) return -1;
    if (!a.isFavorite && b.isFavorite) return 1;
    return new Date(b.modifiedAt) - new Date(a.modifiedAt);
  });

  const favorites = sortedQueries.filter(q => q.isFavorite);
  const recent = sortedQueries.filter(q => !q.isFavorite).slice(0, 10);

  const queryCount = savedQueries?.length || 0;

  return (
    <>
      <Button
        variant='outlined'
        startIcon={<FolderOpenIcon />}
        endIcon={<KeyboardArrowDownIcon />}
        onClick={handleClick}
        disabled={queryCount === 0}
      >
        Saved Queries {queryCount > 0 && `(${queryCount})`}
      </Button>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        PaperProps={{
          style: {
            maxHeight: 500,
            width: 400
          }
        }}
      >
        {queryCount === 0 ? (
          <MenuItem disabled>
            <ListItemText primary='No saved queries' />
          </MenuItem>
        ) : (
          <>
            {favorites.length > 0 && (
              <>
                <Box sx={{ px: 2, py: 1, backgroundColor: '#f5f5f5' }}>
                  <Typography variant='caption' fontWeight='bold'>
                    FAVORITES
                  </Typography>
                </Box>
                {favorites.map((query) => (
                  <MenuItem key={query.id} onClick={() => handleLoadQuery(query)}>
                    <ListItemIcon>
                      <IconButton
                        size='small'
                        onClick={(e) => handleAction(() => onToggleFavorite(query.id), query, e)}
                      >
                        <StarIcon fontSize='small' color='warning' />
                      </IconButton>
                    </ListItemIcon>
                    <ListItemText
                      primary={query.name}
                      secondary={new Date(query.modifiedAt).toLocaleDateString()}
                    />
                    <IconButton
                      size='small'
                      onClick={(e) => handleAction(() => onRenameQuery(query), query, e)}
                    >
                      <EditIcon fontSize='small' />
                    </IconButton>
                    <IconButton
                      size='small'
                      onClick={(e) => handleAction(() => onDuplicateQuery(query.id), query, e)}
                    >
                      <ContentCopyIcon fontSize='small' />
                    </IconButton>
                    <IconButton
                      size='small'
                      color='error'
                      onClick={(e) => handleAction(() => onDeleteQuery(query.id), query, e)}
                    >
                      <DeleteIcon fontSize='small' />
                    </IconButton>
                  </MenuItem>
                ))}
                {recent.length > 0 && <Divider />}
              </>
            )}
            {recent.length > 0 && (
              <>
                {favorites.length > 0 && (
                  <Box sx={{ px: 2, py: 1, backgroundColor: '#f5f5f5' }}>
                    <Typography variant='caption' fontWeight='bold'>
                      RECENT
                    </Typography>
                  </Box>
                )}
                {recent.map((query) => (
                  <MenuItem key={query.id} onClick={() => handleLoadQuery(query)}>
                    <ListItemIcon>
                      <IconButton
                        size='small'
                        onClick={(e) => handleAction(() => onToggleFavorite(query.id), query, e)}
                      >
                        <StarOutlinedIcon fontSize='small' />
                      </IconButton>
                    </ListItemIcon>
                    <ListItemText
                      primary={query.name}
                      secondary={new Date(query.modifiedAt).toLocaleDateString()}
                    />
                    <IconButton
                      size='small'
                      onClick={(e) => handleAction(() => onRenameQuery(query), query, e)}
                    >
                      <EditIcon fontSize='small' />
                    </IconButton>
                    <IconButton
                      size='small'
                      onClick={(e) => handleAction(() => onDuplicateQuery(query.id), query, e)}
                    >
                      <ContentCopyIcon fontSize='small' />
                    </IconButton>
                    <IconButton
                      size='small'
                      color='error'
                      onClick={(e) => handleAction(() => onDeleteQuery(query.id), query, e)}
                    >
                      <DeleteIcon fontSize='small' />
                    </IconButton>
                  </MenuItem>
                ))}
              </>
            )}
            <Divider />
            <MenuItem onClick={() => { onManageAll(); handleClose(); }}>
              <ListItemIcon>
                <SettingsIcon />
              </ListItemIcon>
              <ListItemText primary='Manage All Queries' />
            </MenuItem>
          </>
        )}
      </Menu>
    </>
  );
};

export default SavedQueriesMenu;
